var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('avue-crud',{attrs:{"option":_vm.tableOption,"table-loading":_vm.loading,"data":_vm.listData,"page":_vm.tablePage},on:{"update:page":function($event){_vm.tablePage=$event},"on-load":_vm.loadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }